import { Box, Button, Container, MenuItem, styled } from '@mui/material'

export const ContainerResp = styled(Box)({
  justifyContent: 'space-between',
  padding: '0px',
  width: 'fit-content',
  gap: 8
})

export const ActionButton = styled(Button)({
  startIcon: {
    margin: 0
  },
  contained: {
    borderRadius: 4
  }
})

export const ActionButtonNoLine = styled(Button)({
  root: {
    borderRight: 'none !important'
  },
  startIcon: {
    margin: 0
  },
  contained: {
    borderRadius: 4
  }
})

export const FilterButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[800],
  [theme.breakpoints.down('md')]: {
    paddingTop: 22,
    paddingBottom: 22
  }
}))

export const FilterMenuItem = styled(MenuItem)(({ theme }) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: 170,
    [theme.breakpoints.down('xs')]: {
      borderBottom: `1px solid ${theme.palette.grey[100]}`,
      height: 48,
      gap: 16,
      justifyContent: 'center',
      minWidth: '100vw'
    }
  }
}))

export const ContainerFilter = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginBottom: 16,
  '&.noPadding': {
    padding: '0 !important'
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'space-between'
  },
  [theme.breakpoints.down('xs')]: {
    marginBottom: 0
  }
}))
